import React from 'react'
import TabsPane from './TabsPane'

export default function Body({tabsPaneFn}) {
return (
    <TabsPane fn={tabsPaneFn}/>
    )
}